<div class="flex flex-col items-center justify-center py-4">
  <div class="mb-8">
    <div class="flex h-[126px] w-[210px] items-center justify-center md:h-[320px] md:w-[320px]">
      @if (riveConfig(); as rive) {
        <canvas
          rive
          loading="lazy"
          class="h-full w-full"
          [riveFile]="rive.file"
          [artboard]="rive.artboard"
          [stateMachine]="rive.stateMachine"
          [autoplay]="true"
          width="500"
          height="500"
        ></canvas>
      } @else {
        <dojo-image [src]="imageSrc()" [alt]="'examdojo.no_questions_found' | transloco" />
      }
    </div>
  </div>

  <h3 class="text-primary mb-2 text-xl font-semibold">{{ title() }}</h3>
  <p class="text-secondary mb-8 text-center text-sm">{{ 'examdojo.no_questions_found_description' | transloco }}</p>

  <dojo-button (click)="clearAllFilters()" [fill]="'outline'" [customColor]="'sky'">
    <dojo-icon [icon]="'xmark'" class="mr-1.5" />
    <span>{{ 'examdojo.no_questions_found_clear_all_filters' | transloco }}</span>
  </dojo-button>
</div>
